<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="106"
    height="55"
    viewBox="0 0 106 55"
    fill="none"
  >
    <mask
      id="mask0_2645_56611"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="106"
      height="55"
    >
      <rect
        x="1.25"
        y="0.5"
        width="104"
        height="53.7826"
        fill="#C4C4C4"
        stroke="#27AE60"
      />
    </mask>
    <g mask="url(#mask0_2645_56611)">
      <path
        opacity="0.2"
        d="M17.9295 27.6988C9.43346 27.4281 1.35432 40.1428 -0.832153 45.4446V55.0938H111.935L108.051 13.2287C99.4213 15.5632 90.2158 10.8942 87.5842 10.778C81.6495 10.778 72.7995 24.0889 68.843 31.0827C65.5946 37.3095 61.4507 38.6406 59.7848 38.5278C52.0384 38.7985 46.1454 24.8785 44.1671 17.8847C42.4179 10.0334 40.4487 8.40918 39.4818 8.40919C37.8596 8.40413 35.4212 10.7104 32.9224 18.5616C30.4236 26.4127 26.4671 28.6011 24.8012 28.7139C22.4711 28.8717 19.6995 27.6988 17.9295 27.6988Z"
        fill="url(#paint0_linear_2645_56611)"
      />
      <path
        d="M-0.832153 45.4446C1.35432 40.1428 9.43345 27.4281 17.9295 27.6988C19.6995 27.6988 22.4711 28.8717 24.8012 28.7139C26.4671 28.6011 30.4236 26.4127 32.9224 18.5616C35.4212 10.7104 37.8596 8.40413 39.4818 8.40919C40.4487 8.40918 42.4179 10.0334 44.1671 17.8847C46.1454 24.8786 52.0384 38.7985 59.7848 38.5278C61.4507 38.6406 65.5945 37.3095 68.843 31.0827C72.7995 24.0889 81.6495 10.778 87.5842 10.778C90.2158 10.8942 99.4213 15.5632 108.051 13.2287"
        stroke="#D72638"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <mask id="path-5-inside-1_2645_56611" fill="white">
        <ellipse cx="79.2843" cy="16.1857" rx="1.43835" ry="1.55632" />
      </mask>
      <ellipse
        cx="79.2843"
        cy="16.1857"
        rx="1.43835"
        ry="1.55632"
        fill="white"
      />
      <path
        d="M78.7227 16.1857C78.7227 16.1134 78.7506 16.0174 78.8326 15.9288C78.917 15.8374 79.0757 15.742 79.2843 15.742V19.742C81.3288 19.742 82.7227 17.9985 82.7227 16.1857H78.7227ZM79.2843 15.742C79.4929 15.742 79.6516 15.8374 79.736 15.9288C79.818 16.0174 79.8459 16.1134 79.8459 16.1857H75.8459C75.8459 17.9985 77.2398 19.742 79.2843 19.742V15.742ZM79.8459 16.1857C79.8459 16.2581 79.818 16.354 79.736 16.4427C79.6516 16.534 79.4929 16.6294 79.2843 16.6294V12.6294C77.2398 12.6294 75.8459 14.373 75.8459 16.1857H79.8459ZM79.2843 16.6294C79.0757 16.6294 78.917 16.534 78.8326 16.4427C78.7506 16.354 78.7227 16.2581 78.7227 16.1857H82.7227C82.7227 14.373 81.3288 12.6294 79.2843 12.6294V16.6294Z"
        fill="#D72638"
        mask="url(#path-5-inside-1_2645_56611)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2645_56611"
        x1="55.5514"
        y1="8.40918"
        x2="55.383"
        y2="55.0937"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F15846" />
        <stop offset="1" stop-color="#F15846" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
